import {useMemo} from 'react'
import {styled, Typography} from '@mui/material';
import Value from '../../../../components/Value';

const Container = styled('div')(({theme}) => ({
  background: theme.palette.grey['100'],
  display: 'flex',
  gap: theme.spacing(2),
  padding: theme.spacing(1, 2),
  width: '100%',
}));

const Section = styled('div')(() => ({
  display: 'flex',
  flexWrap: 'wrap',
  flex: 1,
}));

const Title = styled(Typography)(() => ({
  flex: '0 0 100%',
  width: '100%'
}));

const MarginSummary = ({orders}) => {
  const {margins: {eur, gbp}, counts: {withPO, withoutPO}} = useMemo(() => ({
    margins: {
      gbp: orders.filter((
        {
          purchase_order,
          currency
        }
      ) => !!purchase_order && currency === 'GBP').reduce((a, {margin}) => a + margin, 0),
      eur: orders.filter((
        {
          purchase_order,
          currency
        }
      ) => !!purchase_order && currency === 'EUR').reduce((a, {margin}) => a + margin, 0)
    },
    counts: {
      withPO: orders.filter(({purchase_order}) => !!purchase_order).length,
      withoutPO: orders.filter(({purchase_order}) => !purchase_order).length,
    }
  }), [orders]);

  return (
    <Container>
      <Section>
        <Title>Margins</Title>
        <Value value={gbp} currency="GBP"/>&nbsp;&nbsp;/&nbsp;&nbsp;<Value value={eur} currency="EUR"/>
      </Section>
      <Section>
        <Title>With Margins&nbsp;&nbsp;/&nbsp;&nbsp;Without Margins</Title>
        <Value value={withPO}/>&nbsp;&nbsp;/&nbsp;&nbsp;<Value value={withoutPO}/>
      </Section>
    </Container>
  )
}

export default MarginSummary